module.exports = __webpack_public_path__ + "img/pr-6.a84a173c.png";